import { ProjectMembersPage } from "@/features/projects/project-members.page";
import { IncognitoProjectMembersPage } from "@/features/superuser/incognito/project/incognito-project-members.page";
import { useWorkspaceAccess } from "@/features/workspaces/use-workspace-access";
import { ProjectRoute } from "@/routes/_authenticated/workspaces/$slug/projects/$projectSlug";
import { createFileRoute } from "@tanstack/react-router";

function ProjectMembersRoute() {
  const workspaceAccess = useWorkspaceAccess();
  const { project } = ProjectRoute.useRouteContext();

  // CR-165: incognito mode gets the display-only list (no invite, role or
  // leave control); the member page is untouched.
  if (workspaceAccess.mode === "incognito") {
    return <IncognitoProjectMembersPage project={project} />;
  }

  return (
    <ProjectMembersPage
      title="Project Members"
      continueButton={false}
      leaveProjectButton={true}
      joinRequests={true}
    />
  );
}

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/members",
)({
  component: ProjectMembersRoute,
});
